<mat-form-field *transloco="let translate" [appearance]="appearance" appRemoveAriaOwns class="selectGroup">
    <mat-label [textContent]="placeholder"></mat-label>
    <mat-select
        [placeholder]="placeholder"
        [formControl]="control"
        [errorStateMatcher]="matcher"
        disableOptionCentering
        (selectionChange)="errors && errors.splice(0, 1)"
        [title]="getTooltipTitle()"
        panelClass="selectGroupClass addToIgnoreList"
        [multiple]="isMultple">
        <mat-option
            *ngIf="hideSelectIfValueExists !== undefined ? model !== undefined && !hideSelectIfValueExists : true"
            (click)="selected('')">
            <em>
                --
                <span [textContent]="translate('Please select')"></span>
                --
            </em>
        </mat-option>
        <div class="selectSearchFilter addToIgnoreList" *ngIf="options?.length !== 0">
            <mat-form-field class="addToIgnoreList">
                <mat-label *transloco="let translate">{{ translate('Search') }}</mat-label>
                <div class="d-flex">
                    <input
                        matInput
                        class="inputSearchField addToIgnoreList"
                        autocomplete="off"
                        [(ngModel)]="searchColumns"
                        (keydown)="$event.stopPropagation()" />
                    <material-button
                        *ngIf="searchColumns"
                        buttonType="icon"
                        size="small"
                        [titleText]="'Clear'"
                        prefixIconType="material"
                        prefixIcon="close"
                        (buttonClicked)="$event.stopPropagation(); searchColumns = ''"></material-button>
                </div>
            </mat-form-field>
        </div>
        <mat-option *ngIf="options?.length === 0" class="noReportRecord" [disabled]="true">
            <span [textContent]="noOptionsInstruction"></span>
        </mat-option>
        <mat-optgroup *ngFor="let option of options" [label]="option[groupDisplayNameProperty]">
            <mat-option
                *ngFor="
                    let subOption of option[groupValueProperty]
                        | FilterPipe : groupValueProperty || 'value' : searchColumns : null : optionDisplayNameProperty
                "
                [value]="getOptionValue(subOption)"
                [title]="getOptionDisplayText(subOption)"
                (click)="selected(subOption)"
                (onSelectionChange)="selected(subOption)">
                <span [textContent]="getOptionDisplayText(subOption)"></span>
            </mat-option>
            <mat-option
                class="noReportRecord"
                [disabled]="true"
                *ngIf="
                    (
                        option[groupValueProperty || 'value']
                        | FilterPipe : groupValueProperty || 'value' : searchColumns : null : optionDisplayNameProperty || 'displayName'
                    ).length === 0
                ">
                <span [textContent]="translate('No results found')"></span>
            </mat-option>
        </mat-optgroup>
    </mat-select>
    <mat-hint align="start" *ngIf="required && !(errors && errors.length > 0)">
        <strong>
            <span>*</span>
            <span [textContent]="translate('required')"></span>
        </strong>
    </mat-hint>
    <mat-error *ngIf="errors && errors.length > 0" [title]="errors">
        <span [textContent]="errors"></span>
    </mat-error>
</mat-form-field>
